import { ResponsiveObject } from '@fiverr-private/theme/dist/esm/src/components/Box/types';

export const TABBED_CAROUSELS_HEIGHT: Record<string, ResponsiveObject<any>> = {
    DESKTOP: '367px',
    MOBILE: '455.19px',
};
